const staticURLs = {
    consumerActionWebsite: "https://www.usa.gov/features",
    howFileComplaint: "https://consumercomplaints.fcc.gov/hc/en-us",
    protectingIdentity: "https://cdn.ezshield.net/resources/Forms/FAQSandFormsDec72006%20%285%29.doc",
    lettersEquifax: "https://cdn.ezshield.net/resources/Forms/Equifax_DoNotSellLetterFinal_Oct92005%20%281%29.doc",
    lettersToExperian: "https://cdn.ezshield.net/resources/Forms/Experian_ConsumerDoNotSellLetterFinal_October92005.doc",
    letterToCreditBureau: "https://cdn.ezshield.net/resources/Forms/FTC_SampleDisputeLettertoCreditBureaus_Aug252005.doc",
    generalComplaintLetter: "https://cdn.ezshield.net/resources/Forms/SampleComplaintLetter.doc",
    generalComplaintMail: "https://cdn.ezshield.net/resources/Forms/SampleEmailComplaint.doc",
    medicalIdFraudProtectoin: "https://cdn.ezshield.net/resources/Forms/MedicalIDFraudProtectionForm.pdf",
    consumerActionHandbook: "https://cdn.ezshield.net/resources/Forms/Consumer_Action_Handbook_2017.pdf",
    betterBusinessBureau: "https://cdn.ezshield.net/resources/Forms/BBBs.pdf",
    consumerProtection: "https://cdn.ezshield.net/resources/Forms/Consumer_Orgs.pdf",
    quickConsumerTips: "https://cdn.ezshield.net/resources/Forms/Consumer_Topics.pdf",
    corporateConsumerContact: "https://cdn.ezshield.net/resources/Forms/Corporate_Consumer_Offices.pdf",
    federalAgencyContacts: "https://cdn.ezshield.net/resources/Forms/Federal.pdf",
    sampleComplaintLetter: "https://cdn.ezshield.net/resources/Forms/Sample_Complaint.pdf",
    consumerProtectionOffices: "https://cdn.ezshield.net/resources/Forms/State_Offices.pdf",
    tradeProfessionalAssociations: "https://cdn.ezshield.net/resources/Forms/Trade.pdf",
    automotiveDisputeResolutionResources: "https://cdn.ezshield.net/resources/Forms/Auto_Manufacturers.pdf",
    experianCreditFreeze: "https://www.experian.com/freeze/center.html#content-01",
    equifaxCreditFreeze: "https://www.equifax.com/personal/credit-report-services",
    transUnionCreditFreeze: "https://www.transunion.com/credit-freeze",
    loanComparison: "https://secure.identityforce.com/calculators/loan_calculator.htm",
    creditCardComparison: "https://secure.identityforce.com/calculators/cc_calculator.htm",
    autoLeavevsBuy: "https://secure.identityforce.com/calculators/leasevsbuy_calculator.htm",
    mortgageQualification: "https://secure.identityforce.com/calculators/mortgage1_calculator.htm",
    debtConsolidation: "https://secure.identityforce.com/calculators/debt_calculator.htm",
    mortgageRefinancing: "https://secure.identityforce.com/calculators/mortgage2_calculator.htm",
    optOutOfPrescreenedCreditCardOffers: "https://www.optoutprescreen.com/?rf=t",
    telemarketingPhoneCalls: "https://www.donotcall.gov/",
    commercialEmails: "https://www.ims-dm.com/cgi/optoutemps.php",
    commercialMailDMAchoice: "https://www.dmachoice.org/register.php",
    commercialMailLexisNexis: "https://www.lexisnexis.com/privacy/directmarketingopt-out.aspx",
    commercialCouponsValpak: "https://www.valpak.com/coupons/show/mailinglistsuppression",
    commercialCouponsRetailMeNot: "https://www.retailmenot.com/everyday/unsubscribe",
    IDFiOSAPP: "https://apps.apple.com/us/app/identityforce/id1209090711",
    EzsiOSAPP: "https://apps.apple.com/us/app/mysontiq/id516921186",
    EzsAndroidApp: "https://play.google.com/store/apps/details?id=com.ezshield.android",
    IDFAndroidApp: "https://play.google.com/store/apps/details?id=com.identityforce&hl=en",
    BusinessUserAndroidApp: "https://play.google.com/store/apps/details?id=com.sontiq.business.mobile",
    BusinessUseriOSApp: "https://apps.apple.com/us/app/sontiq-small-business/id1472571432",
    consumerDashboardVideo: "https://vimeo.com/493533177",
    businessDashboardVideo: "https://vimeo.com/528338162",
    IDFContactUsPage: "https://www.identityforce.com/about/contact-us",
    CommerceBankCBIAuthURL: "https://banking.commercebank.com/CBI/Auth/Login",
    smallBusinessResBreach: "https://whitehawk.com/business-risk-suite",
    SMBCyberRiskScheduleConsultation: "https://outlook.office365.com/owa/calendar/WhiteHawkCECInc@whitehawk.com/bookings/",
    BusResEduWebinars: "https://www.sontiq.com/resources/?category_name=business-resources&content_type=webinars",
    BusResEduInfographics: "https://www.sontiq.com/resources/?category_name=business-resources&content_type=infographics",
    BusResEduBlogs: "https://www.sontiq.com/resources/?category_name=business-resources&content_type=blogs",
    RepIQGettingStarted: "https://www.youtube.com/embed/6pwPkZ-4S80",
    AvastAuthURL: "",
    SsoUrl: "/app/.ssohandler",
    CyberIdLockAuthURL: "",
    trustPlusURL: "https://go.mytrustplus.org/h310",
};

export { staticURLs };
